import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/dashboard/app-sidebar";
import { Separator } from "@/components/ui/separator";
import { PageHeaderContent } from "@/components/page-header-content";
import { usePageHeader } from "@/contexts/page-header-context";
import { AppBreadcrumb } from "@/components/app-breadcrumb";

const MainLayout = () => {
  const { headerData } = usePageHeader();

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="bg-background">
        <header className="flex h-auto shrink-0 items-center gap-2 border-b px-2 py-2 bg-background min-h-[3.5rem]">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
          <div className="flex items-center ml-2">
            <AppBreadcrumb />
          </div>
          {headerData ? (
            <div className="flex flex-1 items-center justify-end ml-4">
              <div className="flex items-center space-x-4">
                {headerData.stats && (
                  <div className="flex items-center space-x-2 text-sm text-muted-foreground bg-card px-3 py-1.5 rounded-lg border border-border">
                    {headerData.stats.icon}
                    <span className="font-medium">
                      {headerData.stats.count} {headerData.stats.count === 1 ? headerData.stats.label : `${headerData.stats.label}s`}
                    </span>
                  </div>
                )}
                {headerData.actions}
              </div>
            </div>
          ) : (
            <PageHeaderContent />
          )}
        </header>
        <div className="flex flex-1 flex-col gap-2 p-4 pt-0 bg-background w-full">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default MainLayout;
